import { CalendarCheck } from 'lucide-react';
import { serviceCards } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { scrollToId } from './constants';

export const Services = () => {
  const { t } = useLang();
  return (
    <section id="services" className="py-14 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading label={t.servicesSection.label} title={t.servicesSection.title} />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 auto-rows-fr">
          {serviceCards.map((s) => (
            <div
              key={s.key}
              className="group relative flex flex-col h-full overflow-hidden bg-surface border border-white/5 hover:border-gold/40 transition-colors"
              data-testid={`service-card-${s.key}`}
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={s.image}
                  alt={`${t.services[s.key].name} — The Real Turkish Barber Bray`}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex-1">
                <h3 className="font-serif text-lg text-gold mb-1.5">{t.services[s.key].name}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{t.services[s.key].desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <button
            onClick={() => scrollToId('prices')}
            className="inline-flex items-center gap-2 border border-gold text-gold hover:bg-gold hover:text-ink font-bold uppercase tracking-widest px-8 py-4 transition-colors text-sm"
            data-testid="view-all-services-button"
          >
            <CalendarCheck size={16} /> {t.servicesSection.viewAll}
          </button>
        </div>
      </div>
    </section>
  );
};
